<template>
  <modal-padrao
    ref="modal-comentario"
    :titulo="tituloModal"
    max-width="80%"
    :mostraBotaoSalvar="false"
    :tituloCancelar="tituloFechar"
  >
    <div class="py-4 px-3">
      <div v-if="form.id && form.categoria">
        <v-chip class="mr-1" small>
          {{
            $t('modulos.duvida_solicitacao_participante.comentarios.categoria')
          }}:
          {{ `${form.categoria}` }}
        </v-chip>
        <v-chip v-if="form.participante.apelido" class="mr-1" small>
          {{
            $t(
              'modulos.duvida_solicitacao_participante.comentarios.participante'
            )
          }}: {{ `${form.participante.apelido}` }}
        </v-chip>
        <v-chip v-if="form.dataAbertura" class="mr-1" small>
          {{
            $t(
              'modulos.duvida_solicitacao_participante.comentarios.data_abertura'
            )
          }}: {{ formatarData(form.dataAbertura) }}
        </v-chip>
      </div>
      <comentario
        :key="comentarioKey"
        :form="form"
        :permissoes="permissoes"
        origen="duvidaSolicitacaoParticipante"
      />
    </div>
  </modal-padrao>
</template>
<script>
import Comentario from '@/components/comentario/Comentario.vue';
import helpers from '@common/utils/helpers';
export default {
  name: 'ComentarioDuvidaSolicitacaoParticipanteModal',
  components: {
    Comentario,
  },
  data() {
    return {
      form: {},
      comentarioKey: 0,
      permissoes: {
        funcionalidade: 'DuvidaSolicitacaoParticipante',
        acaoComentar: 'Comentar',
        acaoResponder: 'ResponderComentario',
        acaoEncerrar: 'EncerrarComentario',
        acaoExcluir: 'ExcluirComentario',
      },
    };
  },
  computed: {
    tituloModal: function () {
      return this.$t(
        'modulos.orcamentos.tabela.modal_comentario.lista_comentarios'
      );
    },
    tituloFechar: function () {
      return this.$t('modulos.orcamentos.tabela.modal_comentario.fechar');
    },
  },
  methods: {
    abrirModal: function (item) {
      this.comentarioKey += 1;
      this.form = item;
      this.$refs['modal-comentario'].abrirModal();
    },
    formatarData(data) {
      return helpers.formatarDataBr(data, false);
    },
  },
};
</script>

<style>
.py-4 {
  padding: 1.5rem auto;
}

.px-3 {
  padding-block: 0.75rem;
}
</style>
